import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ArticleGestionSearch from './ArticleGestionSearch';
import { fetchSuggestionsArticleGestion, clearSuggestionsArticleGestion, setArticleGestionValue, clearArticleGestionValue } from 'store/articleGestion/articlesGestionActions';

class ArticleGestionSearchContainer extends React.Component {
    
    componentWillUnmount() {
        this.props.clearSuggestionsArticleGestion();
        // On ne clear pas la valeur ici pour la garder active dans la recherche, par contre on la nettoye sur le unmount des composants d'ajout d'action.
        //this.props.clearArticleGestionValue();        
    }

    handleSearchArticlesGestion = (searchValue) => {
        this.props.fetchSuggestionsArticleGestion(searchValue, this.props.infosLogistique);
    }

    handleClearArticlesGestion = () => {
        this.props.clearSuggestionsArticleGestion();
    }

    handleChange = (value) => {
        this.props.setArticleGestionValue(value, {});
        this.props.onChange({});
    }

    handleSuggestionSelected = (suggestion) => {
        this.props.setArticleGestionValue(!suggestion || !suggestion.reference ? '' : suggestion.reference, suggestion);
        this.props.onChange(suggestion);
    }
    

    handleChangeConcerne = (value) => {
        this.props.onChangeConcerne(value);
    }
    

    render() {
        const { articlesGestion, value, selected, isRequired, error, concerneCheckBox, concerne, label, infosLogistique, variant, size, color } = this.props;
        
        let _value = value;

        if (selected && selected.reference && selected.reference.length > 0) {
            _value = `${selected.reference} - ${selected.designation}`;
        }

        return (
            <ArticleGestionSearch
                articlesGestion={articlesGestion}
                onSearch={this.handleSearchArticlesGestion}
                onChange={this.handleChange}
                onClear={this.handleClearArticlesGestion}
                error={error}
                isRequired={isRequired}
                onSuggestionSelected={this.handleSuggestionSelected}
                value={_value}
                selected={selected}
                concerneCheckBox={concerneCheckBox}
                concerne={concerne}
                onChangeConcerne={this.handleChangeConcerne}
                label={label}
                infosLogistique={infosLogistique}
                variant={variant}
                size={size}
                color={color}
            />);
    }
}


const mapStateToProps = (state, ownProps) => ({
    articlesGestion: state.articleGestion.articlesGestion[ownProps.namespace].suggestions.items,
    value: state.articleGestion.articlesGestion[ownProps.namespace].suggestions.value,
    selected: state.articleGestion.articlesGestion[ownProps.namespace].suggestions.selected
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchSuggestionsArticleGestion: (searchValue, infosLogistique) => dispatch(fetchSuggestionsArticleGestion(ownProps.namespace, searchValue, infosLogistique)),
    clearSuggestionsArticleGestion: () => dispatch(clearSuggestionsArticleGestion(ownProps.namespace)),
    clearArticleGestionValue: () => dispatch(clearArticleGestionValue(ownProps.namespace)),    
    setArticleGestionValue: (value, selected) => dispatch(setArticleGestionValue(ownProps.namespace, value, selected))
});






ArticleGestionSearchContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    concerneCheckBox: PropTypes.bool,
    concerne: PropTypes.bool,
    onChangeConcerne: PropTypes.func,
    label: PropTypes.string,
    infosLogistique: PropTypes.bool.isRequired,

    variant: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
};

ArticleGestionSearchContainer.defaultProps = {
    variant: "outlined",
    size: "medium",
    color: "primary",
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleGestionSearchContainer);